import React, { useState, useEffect } from 'react';
import api from '../api';
import { FileText, Plus } from '@phosphor-icons/react';
import CreateReportForm from '../components/CreateReportForm';
import ReportsView from '../components/ReportsView';
import { useAuth } from '../AuthContext';

const CollaboratorDashboard = () => {
  const { userProfile } = useAuth();
  const [stats, setStats] = useState(null);
  const [activeTab, setActiveTab] = useState('create');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const statsRes = await api.get('/dashboard/stats');
      setStats(statsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Carregando...</div>;
  }

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Header */}
      <header className="bg-[#050505] border-b border-[#27272A] sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <img 
            src="/toolserv-logo.png" 
            alt="Toolserv"
            className="h-8"
          />
          <div className="flex items-center gap-4">
            <span className="text-zinc-400 text-sm">{userProfile?.name}</span>
            <button 
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-[#1E1E1E] text-white border border-[#27272A] rounded-sm hover:bg-[#27272A] transition-colors text-sm"
              data-testid="logout-button"
            >
              Sair
            </button>
          </div>
        </div>
      </header>

      {/* Navigation Tabs */}
      <div className="bg-[#121212] border-b border-[#27272A]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-2">
            {[
              { id: 'create', label: 'Criar Relatório', icon: Plus },
              { id: 'reports', label: 'Meus Relatórios', icon: FileText }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors ${
                  activeTab === tab.id 
                    ? 'border-[#FFB800] text-[#FFB800]' 
                    : 'border-transparent text-zinc-400 hover:text-white'
                }`}
                data-testid={`tab-${tab.id}`}
              >
                <tab.icon size={20} />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-[#121212] border border-[#27272A] rounded-sm p-6" data-testid="stat-reports">
            <div className="text-zinc-400 text-sm mb-2">Total de Relatórios</div>
            <div className="metric-value">{stats?.total_reports || 0}</div>
          </div>
          <div className="bg-[#121212] border border-[#27272A] rounded-sm p-6" data-testid="stat-hours">
            <div className="text-zinc-400 text-sm mb-2">Horas Trabalhadas</div>
            <div className="metric-value">{stats?.total_hours_worked?.toFixed(1) || 0}</div>
          </div>
        </div>

        {activeTab === 'create' && <CreateReportForm onSuccess={fetchData} />}
        {activeTab === 'reports' && <ReportsView collaboratorView={true} />}
      </div>
    </div>
  );
};

export default CollaboratorDashboard;
